
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("35RMv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $3tMMZ = parcelRequire("3tMMZ");


var $frIzR = parcelRequire("frIzR");





var $1imNS = parcelRequire("1imNS");


var $82dFP = parcelRequire("82dFP");


var $hsPNq = parcelRequire("hsPNq");




/**
 * @generated SignedSource<<b7232a6811494702b6b65f77d0a25866>>
 * @relayHash fa50d8b3852c56d36be7fac088a9ba4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2cf5ca59f5fab81de5551e1672c3a44fdf58e60691c68a086935b3b0e044502e
const $5948691bb42cc4e0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "CompanyHubTopNavigationQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "CompanyHubTopNavigationQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "fa50d8b3852c56d36be7fac088a9ba4e",
            "id": "2cf5ca59f5fab81de5551e1672c3a44fdf58e60691c68a086935b3b0e044502e",
            "metadata": {},
            "name": "CompanyHubTopNavigationQuery",
            "operationKind": "query",
            "text": "query CompanyHubTopNavigationQuery{user:confluence_atlassianUser(current:true){id,emails{value,isPrimary}}}"
        }
    };
}();
$5948691bb42cc4e0$var$node.hash = "238c0250fbd01b632929613e283475f3";
var $5948691bb42cc4e0$export$2e2bcd8739ae039 = $5948691bb42cc4e0$var$node;






var $dTIqH = parcelRequire("dTIqH");

var $idPUB = parcelRequire("idPUB");

var $9vGun = parcelRequire("9vGun");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $eBBZq = parcelRequire("eBBZq");


var $1B659 = parcelRequire("1B659");


var $3yPEN = parcelRequire("3yPEN");


var $9MAeh = parcelRequire("9MAeh");


var $cAMBp = parcelRequire("cAMBp");


var $eDVeb = parcelRequire("eDVeb");


var $fv9xv = parcelRequire("fv9xv");








var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cv4vy = parcelRequire("cv4vy");




parcelRequire("42omo");

/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $f3b592ea0eca1596$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $f3b592ea0eca1596$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $f3b592ea0eca1596$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}


/**
 * Helper function to create a string of custom query parameters
 * Returns a string like "&orgId=blah&..." that can be appended to URLs
 */ const $3e5c2e4c7ed97548$var$createCustomParametersString = (customParameters)=>{
    if (!customParameters || Object.keys(customParameters).length === 0) return '';
    return Object.entries(customParameters).map(([key, value])=>`&${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('');
};
const $3e5c2e4c7ed97548$var$buildProfileLink = (baseUrl, path, applicationParam, email, logInLinkCustomParameters)=>{
    const profileUrl = `${baseUrl}${path}`;
    if (email) {
        const logInLinkCustomParamsString = $3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters);
        const loginUrl = `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(profileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}${logInLinkCustomParamsString}`;
        return loginUrl;
    }
    return profileUrl;
};
function $3e5c2e4c7ed97548$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, logInLinkCustomParameters: logInLinkCustomParameters }) {
    const { baseUrl: baseUrl } = (0, $f3b592ea0eca1596$export$eabfcea451f48b90)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileLink = $3e5c2e4c7ed97548$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email, logInLinkCustomParameters);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account${$3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters)}`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}${$3e5c2e4c7ed97548$var$createCustomParametersString(logInLinkCustomParameters)}` : undefined
    };
}


const $507d7686e270e70a$export$df97669773647652 = ({ identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, AccountMenu: AccountMenu, ...props })=>{
    const links = (0, $3e5c2e4c7ed97548$export$2afde6c526be23b9)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(AccountMenu, {
        ...props,
        ...links
    });
};


const $e59175270654f550$export$75dc45130eee4ebb = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $507d7686e270e70a$export$df97669773647652), {
        ...props,
        AccountMenu: (0, $cv4vy.AccountMenuNav3)
    });
};



var $7J5Uc = parcelRequire("7J5Uc");





var $9wGTI = parcelRequire("9wGTI");


var $ictHB = parcelRequire("ictHB");


var $disnP = parcelRequire("disnP");

const $41e938af2c9a6719$var$ENV_TO_IDENTITY_ENV = {
    STAGING: 'staging',
    DEVELOPMENT: 'dev',
    PRODUCTION: 'prod'
};
const $41e938af2c9a6719$export$b3f2b8c6cd294d68 = (env)=>$41e938af2c9a6719$var$ENV_TO_IDENTITY_ENV[env] || 'prod';


const $318a934f5d964bb7$export$6602717775dd2fda = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { user: user } = t0;
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    let t1;
    if ($[0] !== user.id) {
        t1 = ()=>(0, $ictHB.fetchGlobalColorMode)(user.id);
        $[0] = user.id;
        $[1] = t1;
    } else t1 = $[1];
    const getThemePreference = t1;
    const [globalColorMode, loadGlobalColorModeOnce] = (0, $disnP.useColorModeState)(getThemePreference, user.id);
    let t2;
    if ($[2] !== user.environment) {
        t2 = (0, $41e938af2c9a6719$export$b3f2b8c6cd294d68)(user.environment);
        $[2] = user.environment;
        $[3] = t2;
    } else t2 = $[3];
    const identityEnvironment = t2;
    let t3;
    if ($[4] !== user.emails) {
        t3 = user?.emails?.find($318a934f5d964bb7$var$_temp)?.value || "";
        $[4] = user.emails;
        $[5] = t3;
    } else t3 = $[5];
    const primaryEmail = t3;
    const displayName = user?.displayName || "";
    let t4;
    if ($[6] !== user.photos) {
        t4 = user?.photos?.find($318a934f5d964bb7$var$_temp2)?.value || "";
        $[6] = user.photos;
        $[7] = t4;
    } else t4 = $[7];
    const photo_0 = t4;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const continueUrl = !renderServerPlaceholder && typeof window !== "undefined" ? window.location.href : "";
    let t5;
    if ($[8] !== globalColorMode) {
        t5 = (0, $9wGTI.fg)("shared-user-preferences") ? globalColorMode : undefined;
        $[8] = globalColorMode;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = themeState?.theme?.colorMode;
    let t7;
    if ($[10] !== continueUrl || $[11] !== displayName || $[12] !== identityEnvironment || $[13] !== loadGlobalColorModeOnce || $[14] !== photo_0 || $[15] !== primaryEmail || $[16] !== t5 || $[17] !== t6 || $[18] !== themingActions.setColorModePreference) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e59175270654f550$export$75dc45130eee4ebb), {
            globalColorMode: t5,
            onThemeSwitcherOpenChange: loadGlobalColorModeOnce,
            testId: "company-hub-profile-button",
            application: "confluence",
            email: primaryEmail,
            identityEnvironment: identityEnvironment,
            continueUrl: continueUrl,
            name: displayName,
            picture: photo_0,
            currentTheme: t6,
            onThemeChange: themingActions.setColorModePreference
        });
        $[10] = continueUrl;
        $[11] = displayName;
        $[12] = identityEnvironment;
        $[13] = loadGlobalColorModeOnce;
        $[14] = photo_0;
        $[15] = primaryEmail;
        $[16] = t5;
        $[17] = t6;
        $[18] = themingActions.setColorModePreference;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
function $318a934f5d964bb7$var$_temp(email) {
    return email?.isPrimary;
}
function $318a934f5d964bb7$var$_temp2(photo) {
    return photo?.isPrimary;
}









var $lAFHW = parcelRequire("lAFHW");


var $1s5hv = parcelRequire("1s5hv");


var $iG5N1 = parcelRequire("iG5N1");


var $63PsI = parcelRequire("63PsI");


var $1NBp8 = parcelRequire("1NBp8");

const $148e6fa056eafe7e$export$cab7880b110e6025 = ()=>{
    const $ = (0, $frIzR.c)(3);
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== companyHubName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iG5N1.CustomLogo), {
            href: t0,
            icon: $148e6fa056eafe7e$var$CompanyHubNavIcon,
            label: companyHubName,
            logo: $148e6fa056eafe7e$var$CompanyHubLogo
        });
        $[1] = companyHubName;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
/**
 * The navigation logo at small viewport widths.
 */ const $148e6fa056eafe7e$var$CompanyHubNavIcon = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
            size: "small",
            shouldUseNewLogoDesign: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
/**
 * The navigation logo at large viewport widths.
 */ function $148e6fa056eafe7e$var$CompanyHubLogo() {
    const $ = (0, $frIzR.c)(10);
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const textRef = (0, $42omo.useRef)(null);
    const [textWidth, setTextWidth] = (0, $42omo.useState)(0);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (textRef.current) {
                const nameTextBox = textRef.current.getBBox();
                setTextWidth(nameTextBox.width);
            }
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== companyHubName) {
        t1 = [
            companyHubName
        ];
        $[1] = companyHubName;
        $[2] = t1;
    } else t1 = $[2];
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
            size: "small",
            shouldUseNewLogoDesign: true
        });
        $[3] = t2;
    } else t2 = $[3];
    const t3 = `0 0 ${textWidth} 32`;
    let t4;
    if ($[4] !== companyHubName) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("text", {
            ref: textRef,
            dominantBaseline: "central",
            x: "0",
            y: "50%",
            fill: "var(--ds-text, #292A2E)",
            fontFamily: "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontSize: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }, companyHubName);
        $[4] = companyHubName;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== textWidth) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.075",
            alignItems: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: textWidth,
            height: "32",
            viewBox: t3
        }, t4));
        $[6] = t3;
        $[7] = t4;
        $[8] = textWidth;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
}



var $jMyy4 = parcelRequire("jMyy4");

/**
 * The top navigation of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `TopNavigation` at confluence/next/packages/app-navigation/src/TopNavigation.tsx
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */ function $abe171926f0f789f$var$CompanyHubTopNavigationComponent() {
    const $ = (0, $frIzR.c)(41);
    const { displayName: displayName, isLoggedIn: isLoggedIn, environment: environment } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t0;
    if ($[0] !== renderServerPlaceholder) {
        t0 = {
            skip: renderServerPlaceholder
        };
        $[0] = renderServerPlaceholder;
        $[1] = t0;
    } else t0 = $[1];
    const { data: emailData, error: emailError } = (0, $jMyy4.useQueryInterop)((0, $5948691bb42cc4e0$export$2e2bcd8739ae039), t0);
    const isAtlassianStaff = $abe171926f0f789f$var$_temp2;
    const { data: photoData, error: photoError } = (0, $jMyy4.useQueryInterop)((0, $fv9xv.default));
    const t1 = emailData?.user?.id ?? null;
    const t2 = photoData?.user?.photos ?? null;
    const t3 = emailData?.user?.emails ?? null;
    let T0;
    let T1;
    let renderError;
    let t4;
    let t5;
    let t6;
    let user_0;
    if ($[2] !== displayName || $[3] !== environment || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
        user_0 = {
            id: t1,
            displayName: displayName,
            photos: t2,
            emails: t3,
            environment: environment
        };
        renderError = $abe171926f0f789f$var$_temp3;
        T1 = (0, $9vGun.TopNavStart);
        t5 = null;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eBBZq.AppSwitcherButton), null);
            $[14] = t6;
        } else t6 = $[14];
        T0 = (0, $1B659.DeveloperButtons);
        t4 = isAtlassianStaff(user_0);
        $[2] = displayName;
        $[3] = environment;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = T0;
        $[8] = T1;
        $[9] = renderError;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = user_0;
    } else {
        T0 = $[7];
        T1 = $[8];
        renderError = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        user_0 = $[13];
    }
    let t7;
    if ($[15] !== T0 || $[16] !== t4) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            isAtlassianStaff: t4
        });
        $[15] = T0;
        $[16] = t4;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $148e6fa056eafe7e$export$cab7880b110e6025), null);
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== T1 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, {
            sideNavToggleButton: t5
        }, t6, t7, t8);
        $[19] = T1;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idPUB.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDVeb.SearchBar), null));
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cAMBp.RovoButton), null);
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MAeh.NotificationsButton), null);
        $[25] = t11;
        $[26] = t12;
    } else {
        t11 = $[25];
        t12 = $[26];
    }
    let t13;
    if ($[27] !== isLoggedIn || $[28] !== user_0) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dTIqH.TopNavEnd), null, t11, t12, isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $318a934f5d964bb7$export$6602717775dd2fda), {
            user: user_0
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3yPEN.LoginButton), null));
        $[27] = isLoggedIn;
        $[28] = user_0;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== emailError || $[31] !== renderError) {
        t14 = emailError && renderError(emailError);
        $[30] = emailError;
        $[31] = renderError;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== photoError || $[34] !== renderError) {
        t15 = photoError && renderError(photoError);
        $[33] = photoError;
        $[34] = renderError;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t10, t13, t14, t15);
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = t9;
        $[40] = t16;
    } else t16 = $[40];
    return t16;
}
function $abe171926f0f789f$var$_temp3(error) {
    if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
}
function $abe171926f0f789f$var$_temp2(user) {
    return user?.emails?.some($abe171926f0f789f$var$_temp) || false;
}
function $abe171926f0f789f$var$_temp(email) {
    return email?.value && (email.value.endsWith("@atlassian.com") || email.value.endsWith("@atlassian.com.invalid") || email.value.endsWith("@usersinbuckets.com"));
}
const $abe171926f0f789f$export$ed6ca7f2734173e6 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS,
    attributes: {
        // Inspired by `TopNavigationBase` at confluence/next/packages/app-navigation/entry-points/topNavigation.tsx
        errorBoundaryId: 'company-hub/top-navigation'
    }
})($abe171926f0f789f$var$CompanyHubTopNavigationComponent);









var $4PPzL = parcelRequire("4PPzL");


var $jln20 = parcelRequire("jln20");


var $lpfM9 = parcelRequire("lpfM9");

/**
 * The {@link https://staging.atlassian.design/components/navigation-system/page-layout/examples | page layout} of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `PageLayout` at confluence/next/packages/page-layout/src/PageLayout.tsx
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */ const $cedecc811b46b190$var$CompanyHubPageLayoutComponent = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsPNq.TopNav), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abe171926f0f789f$export$ed6ca7f2734173e6), null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            errorBoundaryId: "company-hub/page-layout/children"
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1imNS.Main), {
            id: "AkMainContent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS,
            attributes: t2
        }, children));
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lpfM9.PanelLoader), {
            toggleInProductHelp: $cedecc811b46b190$var$_temp
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82dFP.Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true
        }, t1, t3, t4));
        $[5] = t3;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
};
const $cedecc811b46b190$export$de31e0f91c524d8f = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS,
    attributes: {
        // Inspired by `PageLayout` and `PageLayoutInner` at confluence/next/packages/page-layout/src/PageLayout.tsx
        errorBoundaryId: 'company-hub/page-layout'
    }
})($cedecc811b46b190$var$CompanyHubPageLayoutComponent);
function $cedecc811b46b190$var$_temp() {}



var $6mKj3 = parcelRequire("6mKj3");


var $9HB34 = parcelRequire("9HB34");




const $8192fec6448579e6$var$relayEnvironment = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $8192fec6448579e6$export$bbf3d8e57337c75 = ({ children: children })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cedecc811b46b190$export$de31e0f91c524d8f), null, children);
    return (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $8192fec6448579e6$var$relayEnvironment
    }, content) : content;
};
module.exports["CompanyHubMainLayout"] = $8192fec6448579e6$export$bbf3d8e57337c75;

});

parcelRegister("1imNS", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dEIJ1 = parcelRequire("dEIJ1");


var $bgZhH = parcelRequire("bgZhH");

const $d409264451843df7$var$mainElementStyles = {
    root: "_nd5l1gzg _1reo1wug _18m91wug _19121cl4 _152timx3 _qwfh1wug _165teqxy _13wn1if8"
}; /**
    * Use the Main area for the main page content. It has a fluid width and will expand to fill available space.
    */ 
function $d409264451843df7$export$861edd1ccea2f746({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    (0, $dEIJ1.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $gMc0m.default)([
                $d409264451843df7$var$mainElementStyles.root,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: children
        })
    });
}
module.exports["Main"] = $d409264451843df7$export$861edd1ccea2f746;

});

parcelRegister("63PsI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1ytiN = parcelRequire("1ytiN");

function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $8C5kA.default)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $cgtv4.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});
module.exports["useCompanyHubName"] = $acec4613ff860ea3$export$e7c489d818076f3d;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("lpfM9", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("9RsRQ"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("9RsRQ", function(module, exports) {

let $72df74c99046a97c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72df74c99046a97c$var$load("k5Ch2"),
    $72df74c99046a97c$var$load("djob1"),
    $72df74c99046a97c$var$load("6wr18"),
    $72df74c99046a97c$var$load("5UCxV"),
    $72df74c99046a97c$var$load("4yXIN"),
    $72df74c99046a97c$var$load("c7glE"),
    $72df74c99046a97c$var$load("2O2Xv"),
    $72df74c99046a97c$var$load("736as"),
    $72df74c99046a97c$var$load("8VT23"),
    $72df74c99046a97c$var$load("cUIaj"),
    $72df74c99046a97c$var$load("7EorR"),
    $72df74c99046a97c$var$load("lbrvh"),
    $72df74c99046a97c$var$load("Wowvf"),
    $72df74c99046a97c$var$load("ffEVr"),
    $72df74c99046a97c$var$load("cyGuT"),
    $72df74c99046a97c$var$load("hhss7"),
    $72df74c99046a97c$var$load("8hq1F"),
    $72df74c99046a97c$var$load("7FF6A"),
    $72df74c99046a97c$var$load("dAdaw"),
    $72df74c99046a97c$var$load("h3ABO"),
    $72df74c99046a97c$var$load("kC80R"),
    $72df74c99046a97c$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("k7Tf7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $2MPqq = parcelRequire("2MPqq");

const $94cea1b432ccea5e$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2MPqq.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
            children: children
        })
    });
};
module.exports["PopoverProvider"] = $94cea1b432ccea5e$export$bf694c7c431c162a;

});

parcelRegister("a90ar", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs0ez = parcelRequire("cs0ez");

const $fcb2cc293f5cb422$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
module.exports["PopoverTarget"] = $fcb2cc293f5cb422$export$5ad0c0856b469f13;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("igBZP", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d4c731e2a28427e0$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d4c731e2a28427e0$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d4c731e2a28427e0$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d4c731e2a28427e0$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("c9mMn", function(module, exports) {
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $621c6a15c091c99d$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
}; // state of the parent option
const $621c6a15c091c99d$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $621c6a15c091c99d$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $621c6a15c091c99d$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $621c6a15c091c99d$var$baseIconStyles = null;
const $621c6a15c091c99d$var$baseOptionStyles = null;
const $621c6a15c091c99d$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onMouseDown = (0, $42omo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $42omo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $42omo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $621c6a15c091c99d$var$optionStyles.default,
            isFocused && $621c6a15c091c99d$var$optionStyles.focused,
            isDisabled && $621c6a15c091c99d$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $621c6a15c091c99d$var$iconStyles.inherit : $621c6a15c091c99d$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    label: "",
                    primaryColor: $621c6a15c091c99d$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $621c6a15c091c99d$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $621c6a15c091c99d$var$svgStyles = null;
const $621c6a15c091c99d$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $621c6a15c091c99d$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
}; /**
    * __Checkbox option__
    */ 
const $621c6a15c091c99d$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$CheckboxIcon,
        ...props
    }); /**
                * __Radio option__
                */ 
const $621c6a15c091c99d$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$RadioIcon,
        ...props
    });
module.exports["CheckboxOption"] = $621c6a15c091c99d$export$d40cc97ecda916f9;
module.exports["RadioOption"] = $621c6a15c091c99d$export$82ab7168879267a7;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/available-sites` : '/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/v2/accessible-products` : '/gateway/api/v2/accessible-products', requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("lIKKD", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $bWLcG = parcelRequire("bWLcG");

const $4cf80e6d1c5d4415$export$918f8818cfbbeb2c = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $4cf80e6d1c5d4415$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $4cf80e6d1c5d4415$export$918f8818cfbbeb2c;
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $4cf80e6d1c5d4415$export$b2a4e2b0c6417297;

});

parcelRegister("1LBzd", function(module, exports) {
const $a161739fae125cf6$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $a161739fae125cf6$export$2d293d9871c38e91 = Object.keys($a161739fae125cf6$export$e5ee4fe8b989fd09);
const $a161739fae125cf6$export$b7ed752a57b4177b = $a161739fae125cf6$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $a161739fae125cf6$export$2d293d9871c38e91;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("24xEE", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f4e2c76b2dc4439a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f4e2c76b2dc4439a$export$30ab340faaed55d4 = (experience)=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f4e2c76b2dc4439a$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $f4e2c76b2dc4439a$export$30ab340faaed55d4;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("lgqtG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $6cnUO = parcelRequire("6cnUO");


var $dh538 = parcelRequire("dh538");


var $k7Tf7 = parcelRequire("k7Tf7");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $759182b58ca4f194$export$e040768d915476be = ({ children: children, blanketIsTinted: blanketIsTinted })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
        blanketIsTinted: blanketIsTinted
    }, children);
};
$759182b58ca4f194$export$e040768d915476be.displayName = 'SpotlightManager';
module.exports["SpotlightManager"] = $759182b58ca4f194$export$e040768d915476be;

});

parcelRegister("2Ehdd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5izcQ = parcelRequire("5izcQ");


var $dh538 = parcelRequire("dh538");


var $a90ar = parcelRequire("a90ar");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $46b4de62a9eb0177$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children);
};
$46b4de62a9eb0177$export$e29577842f211e22.displayName = 'SpotlightTarget';
module.exports["SpotlightTarget"] = $46b4de62a9eb0177$export$e29577842f211e22;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("2BDjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ff1b999d67869c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lFkSe = parcelRequire("lFkSe");


var $ncxs7 = parcelRequire("ncxs7");


var $9Phth = parcelRequire("9Phth");

const $b9ff1b999d67869c$export$ba912c88d6fa0f00 = ({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label })=>{
    const color = status === 'on_track' || status === 'at_risk' || status === 'off_track' ? (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS,
        health: status
    }) : (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: status,
        health: health
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: color,
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
};
function $b9ff1b999d67869c$export$2e2bcd8739ae039({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        }),
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
}

});

parcelRegister("ncxs7", function(module, exports) {

var $9Phth = parcelRequire("9Phth");

const $dec905367716080f$export$4ee6399ea9bdb374 = ({ customColor: customColor, status: status, health: health })=>customColor || (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP)[$dec905367716080f$export$dc241ab7a519fd3f({
        status: status,
        health: health
    }).derivedStatusKey];
const $dec905367716080f$export$dc241ab7a519fd3f = ({ status: status, health: health })=>{
    const statusKey = $dec905367716080f$var$getValidStatus(status);
    const healthKey = $dec905367716080f$var$getValidHealth(health);
    const derivedStatusKey = statusKey === (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS && healthKey ? healthKey : statusKey;
    return {
        derivedStatusKey: derivedStatusKey,
        derivedStatusLabel: (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP)[derivedStatusKey]
    };
};
const $dec905367716080f$var$getValidStatus = (status)=>status && (0, $9Phth.FOCUS_AREA_STATUS_KEYS_LIST).includes(status) ? status : (0, $9Phth.FOCUS_AREA_STATUS_KEYS).PENDING;
const $dec905367716080f$var$getValidHealth = (health)=>health && (0, $9Phth.FOCUS_AREA_HEALTH_KEYS_LIST).includes(health) ? health : undefined;
module.exports["getFocusAreaIconColor"] = $dec905367716080f$export$4ee6399ea9bdb374;

});

parcelRegister("9Phth", function(module, exports) {
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING = 'pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS = 'in_progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED = 'paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED = 'completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK = 'on_track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK = 'at_risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK = 'off_track';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING = 'Pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS = 'In progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED = 'Paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED = 'Completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK = 'On track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK = 'At risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK = 'Off track';
const $76dba10ec45af105$export$c567f03f9a52e6e = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
};
const $76dba10ec45af105$export$18c983eb7bb605ee = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
};
const $76dba10ec45af105$export$a75c07cb53bf7489 = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b00cb7f00f2a82c0 = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$8ed017a96b82c456 = [
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
];
const $76dba10ec45af105$export$91000048f1c8a9ff = [
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
];
const $76dba10ec45af105$export$521c96d8ff090910 = {
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b4e54ea069601d19 = {
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$357f9a743d453edd = {
    ...$76dba10ec45af105$export$521c96d8ff090910,
    ...$76dba10ec45af105$export$b4e54ea069601d19
};
const $76dba10ec45af105$export$8a9f9b723771f4eb = {
    pending: "var(--ds-icon-accent-gray, #7D818A)",
    in_progress: "var(--ds-icon-accent-gray, #7D818A)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E06C00)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    paused: "var(--ds-icon-accent-gray, #7D818A)",
    completed: "var(--ds-icon-accent-gray, #7D818A)"
};
module.exports["FOCUS_AREA_STATUS_KEYS"] = $76dba10ec45af105$export$c567f03f9a52e6e;
module.exports["FOCUS_AREA_STATUS_KEYS_LIST"] = $76dba10ec45af105$export$8ed017a96b82c456;
module.exports["FOCUS_AREA_HEALTH_KEYS_LIST"] = $76dba10ec45af105$export$91000048f1c8a9ff;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP"] = $76dba10ec45af105$export$357f9a743d453edd;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP"] = $76dba10ec45af105$export$8a9f9b723771f4eb;

});

parcelRegister("kJsRi", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

function $e6b26cca3d43530b$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $4u5NT.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}
module.exports["setInteractionError"] = $e6b26cca3d43530b$export$5b689ca7b019e89f;

});

parcelRegister("e1kiJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a350e81639ab5a88$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");

function $a350e81639ab5a88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $922yL.default)(dirtyDate, days);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("6gF1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $49040fbe3dc0e481$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $e1kiJ = parcelRequire("e1kiJ");


var $b5utg = parcelRequire("b5utg");

function $49040fbe3dc0e481$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $e1kiJ.default)(dirtyDate, -amount);
}

});

parcelRegister("Asv1P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $42omo.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $040545af9856ecf6$export$53c2b9c37c40e0d8;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("4bnNr", function(module, exports) {

var $hdvI3 = parcelRequire("hdvI3");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/project/manifest.ts
var $30baa5fc53208f94$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hdvI3.JiraProjectAriResourceOwner),
    resourceType: (0, $hdvI3.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $30baa5fc53208f94$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
};
module.exports["JiraProjectAri"] = $30baa5fc53208f94$export$75a0a0a7cb0a58ae;

});

parcelRegister("hdvI3", function(module, exports) {
// src/jira/project/types.ts
var $c88c3f6e5a62c5c4$export$99d538a3b04916b1 = "jira", $c88c3f6e5a62c5c4$export$736763838d3aa22e = "project";
module.exports["JiraProjectAriResourceOwner"] = $c88c3f6e5a62c5c4$export$99d538a3b04916b1;
module.exports["JiraProjectAriResourceType"] = $c88c3f6e5a62c5c4$export$736763838d3aa22e;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("7DA0P", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2LczZ = parcelRequire("2LczZ");

const $6a1b9fb9a12a7345$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
module.exports["SearchDialog"] = $6a1b9fb9a12a7345$export$2aadebb53f6015f6;

});

parcelRegister("2LczZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $8c3561b25371e474$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c3561b25371e474$var$SIDEBAR_PANE_WIDTH = 272;
const $8c3561b25371e474$var$resultContainerVerticalPadding = 8;
const $8c3561b25371e474$export$dcefba65c42da69c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s8"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $2azjJ.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $2azjJ.dialogWidth};` : '', " box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $2azjJ.grid).multiple(0.5).px + ' ' + (0, $2azjJ.grid).px + ' ' + (0, $6fnsQ.N50A) + ', 0 0 1px ' + (0, $6fnsQ.N60A)})`, ";border-radius:3px;background-color:var(--ds-surface-overlay, #fff);overflow:hidden;margin-top:", (0, $2azjJ.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
const $8c3561b25371e474$export$d6e44c2a92a613c2 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s7"
})({
    name: "s8tasg",
    styles: "flex:1;display:flex;flex-direction:column;overflow:hidden;max-width:100%;box-sizing:border-box"
});
const $8c3561b25371e474$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s6"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});
const $8c3561b25371e474$export$34a31057caff1acb = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s5"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});
const $8c3561b25371e474$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s4"
})("flex:0 1 auto;width:", $8c3561b25371e474$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $8c3561b25371e474$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s3"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`
});
const $8c3561b25371e474$export$dc065bf90da5c17d = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s2"
})({
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
    flex: '0 0 auto'
});
const $8c3561b25371e474$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$33eeaf745b96a17f, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $l998X.jsx)($8c3561b25371e474$export$34a31057caff1acb, {
                    children: children
                })
            })
        ]
    });
const $8c3561b25371e474$var$totalDialogHeightPx = 776 + $8c3561b25371e474$var$resultContainerVerticalPadding * 2;
const $8c3561b25371e474$var$footerHeight = 48;
const $8c3561b25371e474$var$belowDialogSpace = 224;
const $8c3561b25371e474$var$aiFullDialogPromptHeight = 64;
const $8c3561b25371e474$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s1"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$8c3561b25371e474$var$belowDialogSpace - $8c3561b25371e474$var$footerHeight + (props.showAtlassianHomeSearchLink ? $8c3561b25371e474$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $8c3561b25371e474$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $8c3561b25371e474$var$totalDialogHeightPx + $8c3561b25371e474$var$belowDialogSpace, "px){max-height:", (props)=>`${$8c3561b25371e474$var$totalDialogHeightPx - $8c3561b25371e474$var$footerHeight - (props.aiSearchFullDialogEnabled ? $8c3561b25371e474$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");
const $8c3561b25371e474$export$8644783c0dd52b5e = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ee3sr7s0"
})("position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:", (props)=>props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto', ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){flex-grow:1;}");
module.exports["SearchDialogWrapper"] = $8c3561b25371e474$export$dcefba65c42da69c;
module.exports["ResultContainerOuter"] = $8c3561b25371e474$export$d6e44c2a92a613c2;
module.exports["ResultContainer"] = $8c3561b25371e474$export$ab35601bed9ca017;
module.exports["SidebarScrollContainer"] = $8c3561b25371e474$export$34a31057caff1acb;
module.exports["SidebarContainerPane"] = $8c3561b25371e474$export$6b8430dd9f61a5c7;
module.exports["SidebarContainerBorder"] = $8c3561b25371e474$export$33eeaf745b96a17f;
module.exports["SidebarBottomFixedContainer"] = $8c3561b25371e474$export$dc065bf90da5c17d;
module.exports["SearchDialogContent"] = $8c3561b25371e474$export$c9e0e8491f083dd5;
module.exports["ResultRenderWrapper"] = $8c3561b25371e474$export$8644783c0dd52b5e;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");


var $6fnsQ = parcelRequire("6fnsQ");

function $5648f131343e99e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$56446adcecbeec34 = {
    searchDialog: (0, $dTk3A.layers).dialog()
};
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
const $5648f131343e99e5$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $6fnsQ.N900)})`;
const $5648f131343e99e5$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N300)})`;
const $5648f131343e99e5$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $6fnsQ.N20)})`;
const $5648f131343e99e5$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $6fnsQ.P300)})`;
const $5648f131343e99e5$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
module.exports["zIndex"] = $5648f131343e99e5$export$56446adcecbeec34;
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;
module.exports["primaryTextColour"] = $5648f131343e99e5$export$eeb0307e2964e28d;
module.exports["itemLinkSecondaryColor"] = $5648f131343e99e5$export$7168c0a11fb9ab29;
module.exports["itemHighlightColor"] = $5648f131343e99e5$export$4ac85ff259fe4fce;
module.exports["visitedLinkColor"] = $5648f131343e99e5$export$271fb8b1437b1d62;
module.exports["nowrapEllipsis"] = $5648f131343e99e5$export$b6b16ffe83ef4b56;

});

parcelRegister("bg4YX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $e585c5dc5dea28e7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    componentWillUnmount() {
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(undefined);
    }
    render() {
        const { renderWithErrorInfo: RenderWithErrorInfo } = this.props;
        if (RenderWithErrorInfo && this.state.error && this.state.errorInfo) return /*#__PURE__*/ (0, $l998X.jsx)(RenderWithErrorInfo, {
            error: this.state.error,
            errorInfo: this.state.errorInfo
        });
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = ()=>{
            this.setState({
                error: undefined,
                errorInfo: undefined
            });
        };
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(this.resetErrorBoundary);
    }
}
module.exports["ErrorBoundary"] = $e585c5dc5dea28e7$export$e926676385687eaf;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $5XpHP = parcelRequire("5XpHP");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5XpHP))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("226KS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17b1021e2b775282$var$_react = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("42omo")));

var $17b1021e2b775282$var$_baseNew = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17b1021e2b775282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17b1021e2b775282$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $17b1021e2b775282$var$_react.default.createElement($17b1021e2b775282$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$17b1021e2b775282$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $17b1021e2b775282$var$_default = module.exports.default = $17b1021e2b775282$var$AssetsSchemaIcon;

});

parcelRegister("gXsSh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");

function $fce7c419b91370d9$export$62d325d4ac84165c(WrappedComponent) {
    function WithRoutesContext(props) {
        const $ = (0, $frIzR.c)(3);
        const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
        let t0;
        if ($[0] !== props || $[1] !== routesContext) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...routesContext,
                ...props
            });
            $[0] = props;
            $[1] = routesContext;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    WithRoutesContext.displayName = `withRoutesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithRoutesContext;
}
module.exports["withRoutesContext"] = $fce7c419b91370d9$export$62d325d4ac84165c;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1c52947b4a05fe02fc1b43b80c341c9c>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("bbJes", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ae989161e32c463035303e756b6dca8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8253cef9e63cbd0e$var$_react = $8253cef9e63cbd0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $8253cef9e63cbd0e$var$_baseNew = $8253cef9e63cbd0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8253cef9e63cbd0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8253cef9e63cbd0e$var$ReturnIcon = (props)=>/*#__PURE__*/ $8253cef9e63cbd0e$var$_react.default.createElement($8253cef9e63cbd0e$var$_baseNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$8253cef9e63cbd0e$var$ReturnIcon.displayName = 'ReturnIcon';
var $8253cef9e63cbd0e$var$_default = module.exports.default = $8253cef9e63cbd0e$var$ReturnIcon;

});

parcelRegister("8zs3p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9gVcn = parcelRequire("9gVcn");

const $a2cec1783d8c9bc6$export$8b40a725a91166de = ()=>{
    const isFhsEnabled = (0, $42omo.useContext)((0, $9gVcn.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};
module.exports["useIsFhsEnabled"] = $a2cec1783d8c9bc6$export$8b40a725a91166de;

});

parcelRegister("9gVcn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $2af2b85cff10a1fc$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $42omo.createContext)(()=>(0, $dh538.fg)('navx-full-height-sidebar'));
module.exports["IsFhsEnabledContext"] = $2af2b85cff10a1fc$export$1e91b29ada71c32a;

});

parcelRegister("cvtof", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $6e62a89b3ae4c955$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6e62a89b3ae4c955$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SideNavVisibilityState"] = $6e62a89b3ae4c955$export$eb04201bb6dd1e4e;
module.exports["SetSideNavVisibilityState"] = $6e62a89b3ae4c955$export$f6b496b07d1ea493;

});

parcelRegister("5tnQQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a932c722f95653b7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c2e42a5240f58c746dfd1694482fb8c>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8DN9t = parcelRequire("8DN9t");


var $kXb3C = parcelRequire("kXb3C");

function $a932c722f95653b7$export$2e2bcd8739ae039({ label: label = 'Calendar', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("26eSY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $lIKKD = parcelRequire("lIKKD");

function $81e208d7c03fb2bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e208d7c03fb2bd$var$showAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$showBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81e208d7c03fb2bd$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $81e208d7c03fb2bd$var$defaultHiddenStyles,
            above && $81e208d7c03fb2bd$var$showAboveQueries[above],
            below && $81e208d7c03fb2bd$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $81e208d7c03fb2bd$export$f6a3d19be20f5819;

});

parcelRegister("gHANe", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d5213b14145490b2$export$4dfd297558414f12 = (0, $eSUdr.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;
module.exports["UserContextQuery"] = $d5213b14145490b2$export$4dfd297558414f12;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("2hEyf", function(module, exports) {
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $24ffa0794f8d0bc4$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};
module.exports["fontFallback"] = $24ffa0794f8d0bc4$export$2a99220fb32ec798;

});

parcelRegister("9Zu7R", function(module, exports) {

var $cqKco = parcelRequire("cqKco");


var $1DWH0 = parcelRequire("1DWH0");

const $d7b10312e31a364c$export$208fd20af21dc523 = (0, $1DWH0.default)()((0, $cqKco.default));
module.exports["NotificationIndicator"] = $d7b10312e31a364c$export$208fd20af21dc523;

});

parcelRegister("cqKco", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");

const $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT = 9;
const $28ae02d12db6a953$var$NAVIGATION_CHANNEL = 'navigation';
class $28ae02d12db6a953$var$NotificationIndicator extends (0, $42omo.Component) {
    async componentDidMount() {
        this.notificationLogProvider = await this.props.notificationLogProvider;
        this.refresh('mount');
        this.updateInterval();
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.refreshRate !== this.props.refreshRate) this.updateInterval();
    }
    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
        if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    updateInterval() {
        const { refreshRate: refreshRate } = this.props;
        if (this.intervalId) clearInterval(this.intervalId);
        if (refreshRate && refreshRate > 0) this.intervalId = window.setInterval(this.timerTick, refreshRate);
    }
    render() {
        const { count: count } = this.state;
        const { appearance: appearance, max: max } = this.props;
        return count ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-test-selector": "NotificationIndicator",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                testId: "notification-indicator-badge",
                max: max,
                appearance: appearance,
                children: count
            })
        }) : null;
    }
    constructor(...args){
        super(...args);
        this.intervalId = void 0;
        this.visibilityChangesSinceTimer = 0;
        this.notificationLogProvider = void 0;
        this.state = {
            count: this.props.ssrInitialValue || null
        };
        this.onVisibilityChange = ()=>{
            if (this.props.refreshOnVisibilityChange && this.shouldRefresh()) {
                this.visibilityChangesSinceTimer++;
                this.refresh('visibility');
            }
        };
        this.shouldRefresh = ()=>{
            return typeof document !== 'undefined' && !document.hidden || this.props.refreshOnHidden;
        };
        this.timerTick = ()=>{
            this.visibilityChangesSinceTimer = 0;
            this.refresh('timer');
        };
        this.handleAnalytics = (countUpdateProperties)=>{
            const { newCount: newCount, oldCount: oldCount, source: source } = countUpdateProperties;
            // Only fire an 'activating' analytics event if the notification indicator is 'activating' for the first time
            // ie going from a number of 0 (the indicator is not visible)
            // to a number > 0 (the indicator becomes visible)
            if (this.props.createAnalyticsEvent && newCount > 0 && oldCount === 0) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'activated',
                    attributes: {
                        badgeCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
            if (this.props.createAnalyticsEvent && newCount !== oldCount) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'updated',
                    attributes: {
                        oldCount: oldCount,
                        newCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
        };
        this.refresh = async (source)=>{
            // Provider should be available by this point, if not, we exit.
            if (!this.notificationLogProvider) return;
            // If user is not viewing the webpage, then skip this refresh to avoid unnecessary request.
            if (!this.shouldRefresh()) return;
            const visibilityChangesSinceTimer = this.visibilityChangesSinceTimer;
            const updatingEvent = {
                source: source,
                visibilityChangesSinceTimer: visibilityChangesSinceTimer
            };
            const updatingResult = this.props.onCountUpdating && this.props.onCountUpdating(updatingEvent) || {};
            if (updatingResult.skip) return;
            try {
                const count = updatingResult.countOverride || (await this.notificationLogProvider.countUnseenNotifications({
                    queryParams: {
                        currentCount: this.state.count || 0
                    }
                })).count;
                if (this.state.count === null || this.state.count !== count) {
                    const countUpdateProperties = {
                        oldCount: this.state.count || 0,
                        newCount: count,
                        source: source
                    };
                    this.handleAnalytics(countUpdateProperties);
                    if (this.props.onCountUpdated) this.props.onCountUpdated(countUpdateProperties);
                    this.setState({
                        count: count
                    });
                }
            } catch (e) {
            // Do nothing
            }
        };
    }
}
$28ae02d12db6a953$var$NotificationIndicator.defaultProps = {
    appearance: 'important',
    max: $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT,
    refreshRate: 0,
    refreshOnHidden: false,
    refreshOnVisibilityChange: true
};
var $28ae02d12db6a953$export$2e2bcd8739ae039 = $28ae02d12db6a953$var$NotificationIndicator;
module.exports["default"] = $28ae02d12db6a953$export$2e2bcd8739ae039;

});

parcelRegister("c3uZU", function(module, exports) {
$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("eOM9G")).default);

var $eOM9G = parcelRequire("eOM9G");


});

parcelRegister("eOM9G", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $dh538 = parcelRequire("dh538");

const $5fd92637de1593c4$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $5fd92637de1593c4$export$2e2bcd8739ae039 {
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$5fd92637de1593c4$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        // https://switcheroo.atlassian.com/ui/gates/2bb857fa-a92c-43b4-9f07-79ab8b9f7610/key/post-office_enable-notification-components-graphql
        if ((0, $dh538.fg)('post-office_enable-notification-components-graphql')) {
            const query = `
query NotificationLogClientUnseenCount($workspaceId: String) {
  notifications {
    unseenNotificationCount(workspaceId: $workspaceId)
  }
}`;
            const response = await (0, $dwp40.utils).requestService({
                // Base URL cannot be overridden until REST API is removed
                url: '/gateway/api/graphql'
            }, {
                // Don't add trailing slash, it causes 404s
                path: '',
                ...options,
                queryParams: {
                    query: this.source,
                    ...options.queryParams
                },
                requestInit: {
                    mode: 'cors',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...options.requestInit?.headers
                    },
                    body: JSON.stringify({
                        query: query,
                        variables: {
                            workspaceId: this.cloudId
                        }
                    }),
                    ...options.requestInit
                }
            });
            return {
                count: response.data.notifications.unseenNotificationCount
            };
        }
        return (0, $dwp40.utils).requestService(this.serviceConfig, mergedOptions);
    }
    constructor(baseUrl, cloudId, source = $5fd92637de1593c4$export$b055de0e665cb20c){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.source = void 0;
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
}
module.exports["default"] = $5fd92637de1593c4$export$2e2bcd8739ae039;

});

parcelRegister("cH0rK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $QU6QS = parcelRequire("QU6QS");


var $2ZJmt = parcelRequire("2ZJmt");


var $9wGTI = parcelRequire("9wGTI");

const $704173a03d8ffca7$export$94931606b6900781 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onConfirm: onConfirm } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl || $[1] !== onConfirm) {
        t1 = (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
            message: intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges),
            onConfirm: onConfirm
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Prompt), {
            message: ()=>{
                if (confirm(intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges))) {
                    onConfirm();
                    return true;
                }
                return false;
            }
        });
        $[0] = intl;
        $[1] = onConfirm;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $704173a03d8ffca7$var$i18n = (0, $cgtv4.defineMessages)({
    unsavedChanges: {
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    }
});
module.exports["UnsavedNotificationCommentDraftPrompt"] = $704173a03d8ffca7$export$94931606b6900781;

});

parcelRegister("f4ikL", function(module, exports) {
const $e427a1545778ede9$export$8ceafede401119f2 = (intl)=>{
    const confirmMessage = intl.formatMessage({
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    });
    return window.confirm(confirmMessage);
};
const $e427a1545778ede9$export$7bc0d27643cb0f0 = (event)=>{
    // Check if the close event was triggered by a link click
    if (event && event.type === 'click') {
        const target = event.target;
        const link = target.closest('a');
        if (link && link.href && !link.href.startsWith('javascript:')) // If it's a link click, don't show confirmation - let Prompt handle it
        return true;
    }
    return false;
};
const $e427a1545778ede9$export$5e3c850ff2c69d53 = (event, intl, onClose)=>{
    if ($e427a1545778ede9$export$7bc0d27643cb0f0(event)) return;
    if (event && event.type === 'keydown') {
        const keyboardEvent = event;
        if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') {
            if (!$e427a1545778ede9$export$8ceafede401119f2(intl)) return;
        }
    }
    onClose();
};
module.exports["confirmDiscardNotificationCommentDraft"] = $e427a1545778ede9$export$8ceafede401119f2;
module.exports["handlePopupCloseWithUnsavedChanges"] = $e427a1545778ede9$export$5e3c850ff2c69d53;

});

parcelRegister("41c4c", function(module, exports) {

var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");

const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>{
    return (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER)
    });
};
module.exports["preloadProfileMenu"] = $c0dbaa4ed1720915$export$5ca34e43e28ce619;

});

parcelRegister("kLRO8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8MTIk = parcelRequire("8MTIk");

const $a12fcbbfbeaca916$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MTIk.IconButton), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$a12fcbbfbeaca916$export$2e2bcd8739ae039 = (_props)=>{};
module.exports["Profile"] = $a12fcbbfbeaca916$export$5120f2d0b8d4cab8;

});

parcelRegister("4qrTW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8K0Og = parcelRequire("8K0Og");

const $14a2b16d436ce3a5$export$93d4e7f90805808f = ()=>(0, $42omo.useContext)((0, $8K0Og.ThemeContext));
module.exports["useTheme"] = $14a2b16d436ce3a5$export$93d4e7f90805808f;

});

parcelRegister("8K0Og", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ahT8g = parcelRequire("ahT8g");

const $64b78fb356e75cc1$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ahT8g.defaultTheme));
const $64b78fb356e75cc1$export$d8964aec282183a3 = $64b78fb356e75cc1$export$2c657da244d00bd6.Provider;
module.exports["ThemeContext"] = $64b78fb356e75cc1$export$2c657da244d00bd6;
module.exports["ThemeProvider"] = $64b78fb356e75cc1$export$d8964aec282183a3;

});

parcelRegister("ahT8g", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");


var $lCH0w = parcelRequire("lCH0w");


var $jeF0t = parcelRequire("jeF0t");

const $245571a50d5c46d4$export$eeee8619e1b91cb0 = (0, $jeF0t.generateTheme)({
    name: (0, $lCH0w.DEFAULT_THEME_NAME),
    backgroundColor: (0, $6fnsQ.N0),
    highlightColor: (0, $6fnsQ.B400)
});
const $245571a50d5c46d4$export$164de7ab8df77ef0 = $245571a50d5c46d4$export$eeee8619e1b91cb0;
module.exports["atlassianTheme"] = $245571a50d5c46d4$export$eeee8619e1b91cb0;
module.exports["defaultTheme"] = $245571a50d5c46d4$export$164de7ab8df77ef0;

});

parcelRegister("lCH0w", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");


var $3cLqS = parcelRequire("3cLqS");

const $08762123b36e773e$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B400), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B400), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $6fnsQ.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $6fnsQ.B400)})`,
            color: `var(--ds-text, ${(0, $6fnsQ.N700)})`,
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.N200), 0.3)})`}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: `var(--ds-text, ${(0, $6fnsQ.N700)})`
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $6fnsQ.B400)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $6fnsQ.B400)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
                color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
                borderColor: `var(--ds-border-input, ${(0, $6fnsQ.N100)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $6fnsQ.N0)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $08762123b36e773e$var$defaultThemeCopy = JSON.parse(JSON.stringify($08762123b36e773e$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $08762123b36e773e$export$77823bc9863eaa03 = $08762123b36e773e$var$defaultThemeCopy;
const $08762123b36e773e$export$2491e13b198e597d = 'atlassian';
var $08762123b36e773e$export$2e2bcd8739ae039 = $08762123b36e773e$var$defaultTheme;
module.exports["defaultThemeBrandRefresh"] = $08762123b36e773e$export$77823bc9863eaa03;
module.exports["DEFAULT_THEME_NAME"] = $08762123b36e773e$export$2491e13b198e597d;

});

parcelRegister("3cLqS", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");

const $6a9c68de2b00e336$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $lcPXp.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $6a9c68de2b00e336$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $6a9c68de2b00e336$var$hex = '[a-z0-9]';
const $6a9c68de2b00e336$var$shortHandHexColorPattern = new RegExp(`#(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})`, 'i');
const $6a9c68de2b00e336$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $6a9c68de2b00e336$var$isShortHexColor = (color)=>color && color.length === 4;
const $6a9c68de2b00e336$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$6a9c68de2b00e336$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $6a9c68de2b00e336$var$completeTriplet = (colors)=>`#${$6a9c68de2b00e336$var$repeat(colors[1], 6)}`;
const $6a9c68de2b00e336$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $6a9c68de2b00e336$export$db8d2130677f868c = (color)=>{
    if ($6a9c68de2b00e336$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($6a9c68de2b00e336$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($6a9c68de2b00e336$var$isTriplet(colors)) return $6a9c68de2b00e336$var$completeTriplet(colors);
            else return $6a9c68de2b00e336$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $6a9c68de2b00e336$export$10a10e7cd1193377 = (color)=>{
    const converted = $6a9c68de2b00e336$export$db8d2130677f868c(color);
    return (0, $lcPXp.default).contrastRatio(converted).hex;
};
const $6a9c68de2b00e336$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$6a9c68de2b00e336$export$7229be6d7219ee6a((0, $lcPXp.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["hexToRGBA"] = $6a9c68de2b00e336$export$7229be6d7219ee6a;
module.exports["getBoxShadow"] = $6a9c68de2b00e336$export$bba5a971afe05444;
module.exports["generateTextColor"] = $6a9c68de2b00e336$export$10a10e7cd1193377;
module.exports["getContrastColor"] = $6a9c68de2b00e336$export$77a1051494882576;

});

parcelRegister("jeF0t", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $3cLqS = parcelRequire("3cLqS");

const $1ebbdfb973eaad0e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $1ebbdfb973eaad0e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $1ebbdfb973eaad0e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.65) : (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.8) : (0, $3cLqS.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        }
    };
};
const $1ebbdfb973eaad0e$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $3cLqS.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $1ebbdfb973eaad0e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $3cLqS.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lCH0w.DEFAULT_THEME_NAME)) return 0, $lCH0w.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $1ebbdfb973eaad0e$var$generateButtonCSSStates($1ebbdfb973eaad0e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $3cLqS.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $3cLqS.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $3cLqS.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $3cLqS.getBoxShadow)((0, $3cLqS.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $3cLqS.getContrastColor)(0.1, $1ebbdfb973eaad0e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $1ebbdfb973eaad0e$export$2e4ecffaca289a18;

});

parcelRegister("3sMdn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $3scmi = parcelRequire("3scmi");


var $56M4r = parcelRequire("56M4r");


var $6F6hl = parcelRequire("6F6hl");


var $hmRr5 = parcelRequire("hmRr5");


var $4cUZH = parcelRequire("4cUZH");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $0affb4f68c8513c7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $4cUZH.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $hmRr5.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
                "aria-current": undefined,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $0affb4f68c8513c7$export$2e2bcd8739ae039 = $0affb4f68c8513c7$var$DropdownItemRadio;
module.exports["default"] = $0affb4f68c8513c7$export$2e2bcd8739ae039;

});

parcelRegister("hmRr5", function(module, exports) {
/* radio-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $01850bf21ecc815c$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $01850bf21ecc815c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $01850bf21ecc815c$export$2e2bcd8739ae039 = $01850bf21ecc815c$var$RadioIcon;
module.exports["default"] = $01850bf21ecc815c$export$2e2bcd8739ae039;

});

parcelRegister("4cUZH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $al7hi = parcelRequire("al7hi");


var $nVQ0B = parcelRequire("nVQ0B");

function $1119aafb00a8a88b$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $42omo.useContext)((0, $nVQ0B.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $42omo.useContext)((0, $al7hi.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $42omo.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
	 * Set the initial state of the context provider's store,
	 * if it doesn't already have a persisted value for this id.
	 */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $1119aafb00a8a88b$export$2e2bcd8739ae039 = $1119aafb00a8a88b$var$useRadioState;
module.exports["default"] = $1119aafb00a8a88b$export$2e2bcd8739ae039;

});

parcelRegister("al7hi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $nVQ0B = parcelRequire("nVQ0B");


var $6VVpF = parcelRequire("6VVpF");

const $e4983ebd720c0bde$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $42omo.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ee7An.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $e4983ebd720c0bde$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $42omo.useContext)((0, $nVQ0B.SelectionStoreContext));
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $42omo.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $6VVpF.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($e4983ebd720c0bde$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $e4983ebd720c0bde$export$2e2bcd8739ae039 = $e4983ebd720c0bde$var$DropdownItemRadioGroup;
module.exports["RadioGroupContext"] = $e4983ebd720c0bde$export$a79eda4ff50e30b6;
module.exports["default"] = $e4983ebd720c0bde$export$2e2bcd8739ae039;

});

parcelRegister("6VVpF", function(module, exports) {
const $109bffbad6ce930e$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $109bffbad6ce930e$export$2e2bcd8739ae039 = $109bffbad6ce930e$var$resetOptionsInGroup;
module.exports["default"] = $109bffbad6ce930e$export$2e2bcd8739ae039;

});

parcelRegister("2yFMK", function(module, exports) {
const $ec6571ee54ae36da$export$30fa7cc5f2690a43 = 56;
const $ec6571ee54ae36da$export$4033a111ca79977d = 1280;
const $ec6571ee54ae36da$export$24ec62cee78b7042 = 1130;
const $ec6571ee54ae36da$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ec6571ee54ae36da$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ec6571ee54ae36da$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ec6571ee54ae36da$export$d81606c1fc5119bc = '--ds--ans--c';
const $ec6571ee54ae36da$export$65f656ad520ea71 = '--ds--ans--bc';
module.exports["HORIZONTAL_GLOBAL_NAV_HEIGHT"] = $ec6571ee54ae36da$export$30fa7cc5f2690a43;
module.exports["PRODUCT_HOME_BREAKPOINT"] = $ec6571ee54ae36da$export$4033a111ca79977d;
module.exports["CREATE_BREAKPOINT"] = $ec6571ee54ae36da$export$24ec62cee78b7042;

});

parcelRegister("6CCa2", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $dh538 = parcelRequire("dh538");


var $dS0qJ = parcelRequire("dS0qJ");

var $7f54826d8f69d9e8$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9 = 3;
const $7f54826d8f69d9e8$export$4d19f25c7b83dd4a = (0, $gLLcz.z).object({
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$9bcc9fe305679f00 = (0, $gLLcz.z).object({
    /** Unique key identifying the current ghost text set */ id: (0, $gLLcz.z).string(),
    /** Locale of the ghost text */ locale: (0, $gLLcz.z).string(),
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$b18cd5530389e27a = (data)=>{
    try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(data);
        return result.success;
    } catch  {
        return false;
    }
};
const $7f54826d8f69d9e8$export$bd8829925eef3cc2 = (customPlaceholder, locale)=>{
    if (!(0, $dh538.fg)('quickfind-ghosttext')) return undefined;
    if (!customPlaceholder) return undefined;
    if (!(0, $dS0qJ.isEnglishLocale)(locale) && !(0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) return undefined;
    if ((0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
    try {
        const result = $7f54826d8f69d9e8$export$4d19f25c7b83dd4a.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};
module.exports["GhostTextExperimentCohort"] = $7f54826d8f69d9e8$export$6891b88a23696d;
module.exports["ROTATION_THRESHOLD"] = $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9;
module.exports["isGhostTextDataV2"] = $7f54826d8f69d9e8$export$b18cd5530389e27a;
module.exports["parseGhostTextData"] = $7f54826d8f69d9e8$export$bd8829925eef3cc2;

});

parcelRegister("dS0qJ", function(module, exports) {
const $c4d36ce3018afd80$export$3ea53827ed349b2e = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return locale.toLowerCase().startsWith('en');
};
module.exports["isEnglishLocale"] = $c4d36ce3018afd80$export$3ea53827ed349b2e;

});

parcelRegister("bHjhd", function(module, exports) {

var $kiOFr = parcelRequire("kiOFr");

const $89598f5ca555d4d3$export$7fa7ed95afa3407a = (cloudId, gatewayBaseUrl)=>{
    const { data: data, loading: loading, error: error } = (0, $kiOFr.useAvailableSites)({
        gatewayBaseUrl: gatewayBaseUrl
    });
    const filterData = data.filter((site)=>site.cloudId === cloudId);
    if (filterData.length > 0) return {
        data: filterData[0].url,
        loading: loading,
        error: error
    };
    return {
        data: undefined,
        loading: loading,
        error: error
    };
};
module.exports["useCloudIdToUrl"] = $89598f5ca555d4d3$export$7fa7ed95afa3407a;

});


//# sourceMappingURL=CompanyHubMainLayout.1bc2047f.js.map
